// This file was auto-generated by Fern from our API Definition.
export const SecretKind = {
    ProviderKey: "provider_key",
    CustomProvider: "custom_provider",
    SsoProvider: "sso_provider",
    WebhookProvider: "webhook_provider",
    CustomSecret: "custom_secret",
    ChannelSecret: "channel_secret",
    SubscriptionProvider: "subscription_provider",
    OauthProvider: "oauth_provider",
    OauthGrant: "oauth_grant",
};
